import { Component, OnInit, DoCheck } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, Platform } from '@ionic/angular';
import {
  AuthenticationService,
  AlertService,
  GlobalService,
} from 'src/app/shared/_services';
import { DatePipe, DecimalPipe, Location } from '@angular/common';
import { TransactionDetailsPage } from 'src/app/shared/modals/transaction-details/transaction-details.page';
import { FirebaseDynamicLinks } from '@ionic-native/firebase-dynamic-links/ngx';
import { LocalNotifications } from '@ionic-native/local-notifications/ngx';
// import { FCM } from 'cordova-plugin-fcm-with-dependecy-updated/ionic';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { url } from 'src/environments/environment';
import {
  CashiersStore,
  DashboardStore,
  LoginStore,
  PaymentsStore,
  SignupStore,
  TransactionsStore,
} from 'src/app/shared/_services/store';
import { UpgradeStore } from 'src/app/shared/_services/store/upgradeStore.service';

declare var $zopim: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.page.html',
  styleUrls: ['./dashboard.page.scss'],
  providers: [
    DatePipe,
    DecimalPipe,
    FirebaseDynamicLinks,
    InAppBrowser,
    LocalNotifications,
  ],
})
export class DashboardPage implements OnInit, DoCheck {
  today = Date.now();
  epochDateTime = new Date().getTime();
  datePickerValue: any;
  todayDate: string;
  pickerDate: string;
  offset: any;
  currentUser: any;
  currentUserName = this.dashboardStore.getCurrentUserName();
  previousEmail: string;
  cashier: any;
  merchant: any;
  subscription: any;
  searched: any;
  bankTransferCount = this.dashboardStore.getBankTransferCount();
  ussdCount = this.dashboardStore.getUssdCount();
  bankTransferCountArray: any = [];
  ussdCountArray: any = [];
  accounts = [];
  newAccount = [];
  transactionDetails = [];
  newTransactionDetails = [];
  paymentMethods = ['Bank Transfer', 'USSD'];
  amountReceived = this.dashboardStore.getAmountReceived();
  balance = this.dashboardStore.getBalance();
  transactionCount: number;
  hideBalance: boolean;
  gettingData: boolean;
  noConnection = false;
  showMore: boolean;
  active: number = null;
  cordova: boolean;
  mobile: boolean;
  desktop: boolean;
  activeIndex = this.dashboardStore.getActiveIndex();
  id = 0;
  cashiersLength: any;
  accountIdsArray = [];
  merchantAccount: any;
  showMoreButton = false;
  isInfoDismissed: boolean;

  constructor(
    private router: Router,
    private iab: InAppBrowser,
    private platform: Platform,
    private location: Location,
    private datePipe: DatePipe,
    private loginStore: LoginStore,
    private decimalPipe: DecimalPipe,
    private signupStore: SignupStore,
    private upgradeStore: UpgradeStore,
    private alertService: AlertService,
    private auth: AuthenticationService,
    private globalService: GlobalService,
    private cashiersStore: CashiersStore,
    private paymentsStore: PaymentsStore,
    private dashboardStore: DashboardStore,
    private modalController: ModalController,
    private transactionsStore: TransactionsStore,
    private localNotifications: LocalNotifications,
    private firebaseDynamicLinks: FirebaseDynamicLinks
  ) {
    this.currentUser = this.auth.currentUserValue;
  }

  // Pages methods to navigate to respective pages
  managers() {
    this.alertService.closeMenu();
    if (this.merchant) {
      this.router.navigateByUrl('/managers');
    } else {
      this.alertService.notAllowed();
    }
  }
  cashiers() {
    this.alertService.closeMenu();
    if (this.merchant) {
      this.router.navigateByUrl('/cashiers');
    } else {
      this.alertService.notAllowed();
    }
  }
  profile() {
    this.alertService.closeMenu();
    this.router.navigateByUrl('/profile');
  }
  withdrawFunds() {
    if (this.merchant) {
      this.alertService.closeMenu();
      this.router.navigateByUrl('/withdraw');
    } else {
      this.alertService.standardAlertNullDuration(
        'Sorry you are not allowed access to this page'
      );
    }
  }
  reports() {
    if (this.merchant) {
      this.alertService.closeMenu();
      this.router.navigateByUrl('/reports');
    } else {
      this.alertService.standardAlertNullDuration(
        'Sorry you are not allowed access to this page'
      );
    }
  }
  pending() {
    this.alertService.closeMenu();
    this.router.navigateByUrl('/pending');
  }
  notifications() {
    this.alertService.closeMenu();
    this.router.navigateByUrl('/notifications');
  }
  transactions() {
    this.alertService.closeMenu();
    this.router.navigateByUrl('/transactions');
  }
  addNewAccount() {
    if (this.merchant) {
      this.alertService.closeMenu();
      this.router.navigate(['/signup'], {
        queryParams: { addNewAccount: true },
      });
    } else {
      this.notAllowed();
    }
  }
  contactUs() {
    this.alertService.closeMenu();
  }

  newPayment() {
    this.alertService.newPayment();
  }

  newPaymentVia(paymentMethod: string) {
    if (paymentMethod.includes('Transfer')) {
      this.paymentsStore.setPaymentMethod('bankTransfer');
    } else if (paymentMethod.includes('USSD')) {
      this.paymentsStore.setPaymentMethod('ussd');
    }
    this.router.navigateByUrl('/new-payment');
  }

  openSideMenu() {
    this.alertService.openSideMenu();
  }

  showOptions(ev: any) {
    this.alertService.showOptions(ev);
  }

  logout() {
    this.alertService.logoutAlert();
  }

  notAllowed() {
    this.alertService.standardAlertNullDuration(
      'Sorry you are not allowed access to this page'
    );
  }

  toggleBalance() {
    this.hideBalance === false
      ? (this.hideBalance = true)
      : (this.hideBalance = false);
    this.dashboardStore.setIsBalanceHidden(this.hideBalance);
    // if (this.platform.is('ios') && this.auth.currentUserValue.role !== 'merchant') {
    //   // FCM.
    //   this.localNotifications.schedule([
    //     {
    //       id: new Date().getTime(),
    //       title: 'Working',
    //       text: 'Should work normally for the final time!',
    //     }
    //   ]);
    // }
  }

  toggleShowMore() {
    this.showMore === false ? (this.showMore = true) : (this.showMore = false);
    this.dashboardStore.setIsMoreShown(this.showMore);
  }

  dismissInfo() {
    this.isInfoDismissed === false
      ? (this.isInfoDismissed = true)
      : (this.isInfoDismissed = false);
    this.dashboardStore.setIsInfoDismissed(this.isInfoDismissed);
  }

  liveChat() {
    $zopim.livechat.set({
      language: 'en',
      name: this.currentUserName,
      email: this.currentUser.details.email,
      phone: this.currentUser.details.phone
    });
    if (this.platform.is('android')) {
      $zopim.livechat.window.show();
    } else if (this.platform.is('ios')) {
      this.iab.create(
        // tslint:disable-next-line:max-line-length
        'https://v2.zopim.com/widget/livechat.html?api_calls=%5B%5B%22window.setTitle%22%2C%5B%22Bank3D%20Chat%20Support%22%5D%5D%2C%5B%22theme.setColors%22%2C%5B%7B%22%22%3A%22%230094ea%22%7D%5D%5D%5D&hostname=localhost&key=3Pi5OaOjgZF9KeAzzKbmfTswxZLqrXyI&lang=en&'
      );
    }
  }

  switchAccount(account: any, index: any) {
    this.active = index;
    this.alertService.closeMenu();
    this.dashboardStore.setAccountId(account.id);
    this.dashboardStore.setCurrentUserName(account.name);
    this.dashboardStore.setActiveIndex(index);
    this.dashboardStore.setIsNewAccountAdded(true);
    this.currentUserName = account.name;
    this.getUpgradeInfo();
    this.getAmountReceivedAndBalance();
    this.getTransactionCount();
    this.getTransactions();
    this.getCashiers();
    this.auth.getSummary(account.id).subscribe(
      (response) => {
        console.log(response);
        this.dashboardStore.setAccountSummary(response);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  changeDate(ev: any) {
    const date = ev.detail.value;
    this.epochDateTime = new Date(date).getTime();
    this.todayDate = this.datePipe.transform(this.today, 'yyyy-MM-dd');
    this.pickerDate = this.datePipe.transform(this.epochDateTime, 'yyyy-MM-dd');

    const dateText = document.getElementById('date-text');
    const dateTextInner: HTMLElement =
      dateText.shadowRoot.querySelector('.datetime-text');
    dateTextInner.innerText = new Date(this.epochDateTime).toDateString();
    this.dashboardStore.setIsDateChanged(true);
    this.dashboardStore.setPickerDate(this.pickerDate);

    this.newTransactionDetails = [];
    this.getTransactionCount();

    this.dashboardStore.setBankTransferCount(this.bankTransferCount);
    this.dashboardStore.setUssdCount(this.ussdCount);

    this.getTransactions();
    this.getAmountReceived();

    if (this.todayDate === this.pickerDate) {
      dateTextInner.innerText = '';
    } else {
      return;
    }
  }

  async openTransactionDetails(transactionDetail: any) {
    console.log(transactionDetail);
    const modal = await this.modalController.create({
      component: TransactionDetailsPage,
      backdropDismiss: true,
      showBackdrop: true,
      swipeToClose: true,
      mode: 'ios',
      cssClass: 'bottom-modal create-dispute',
      componentProps: { transactionDetail },
    });
    return await modal.present();
  }

  getBalance() {
    if (this.merchant) {
      this.auth.getBalance().subscribe(
        (response: any) => {
          console.log(response);
          this.dashboardStore.setBalance(response.balance);
          this.balance = this.decimalPipe.transform(
            this.dashboardStore.getBalance(),
            '1.2-2'
          );
        },
        (error) => {
          console.log(error);
          this.dashboardStore.setBalance('---');
          // this.balance = '0.00';
        }
      );
    }
  }

  getAmountReceived() {
    this.auth.getAmountReceived(this.pickerDate).subscribe(
      (response: any) => {
        console.log(response);
        this.dashboardStore.setAmountReceived(response.total);
        this.amountReceived = this.decimalPipe.transform(
          this.dashboardStore.getAmountReceived(),
          '1.2-2'
        );
      },
      (error) => {
        console.log(error);
        this.dashboardStore.setAmountReceived('---');
      }
    );
  }

  getTransactionTypeCount() {
    if (this.transactionDetails.length > 0) {
      this.transactionDetails.forEach((transactionDetail) => {
        if (transactionDetail.virtualAccount) {
          this.bankTransferCountArray.push(parseFloat(transactionDetail));
        }
        if (transactionDetail.ussdString) {
          this.ussdCountArray.push(parseFloat(transactionDetail));
        }
      });
      this.bankTransferCount = this.bankTransferCountArray.length;
      this.ussdCount = this.ussdCountArray.length;
      this.dashboardStore.setBankTransferCount(this.bankTransferCount);
      this.dashboardStore.setUssdCount(this.ussdCount);
    } else {
      this.getTransactionCount();

      this.dashboardStore.setBankTransferCount(this.bankTransferCount);
      this.dashboardStore.setUssdCount(this.ussdCount);
    }
  }

  getTransactionCount() {
    this.bankTransferCount = '0';
    this.ussdCount = '0';
  }

  getTransactions() {
    this.gettingData = true;
    this.auth
      .getTransactions(
        this.pickerDate,
        20,
        this.offset,
        this.bankTransferCount,
        this.ussdCount,
        ''
      )
      .subscribe(
        (response: any) => {
          console.log(response);
          this.transactionCount = response.count;
          this.transactionsStore.setTransactionCount(response.count);
          this.storeTransactionDetails(response.transaction);
          this.gettingData = false;
          this.getTransactionTypeCount();
          this.bankTransferCountArray = [];
          this.ussdCountArray = [];
          this.noConnection = false;
        },
        (error) => {
          console.log(error);
          if (
            error.status === 0 ||
            error.statusText.includes('Unknown Error')
          ) {
            this.noConnection = true;
            this.transactionsStore.setTransactionDetails([]);
            this.gettingData = true;
          }
        }
      );
  }

  refreshTransactions(event: any) {
    this.gettingData = true;
    const rotate = document.getElementById('rotate');
    if (event === null) {
      rotate.classList.add('icon-reload');
    }
    console.log('Refreshing to get all transactions and balance', event);
    this.getAmountReceived();
    this.getBalance();
    this.auth
      .getTransactions(
        this.pickerDate,
        20,
        this.offset,
        this.bankTransferCount,
        this.ussdCount,
        ''
      )
      .subscribe(
        (response: any) => {
          console.log('Transactions and balance updated');
          if (event === null) {
            rotate.classList.remove('icon-reload');
          }
          this.noConnection = false;
          this.gettingData = false;
          this.transactionCount = response.count;
          this.newTransactionDetails = response.transaction;
          this.transactionDetails = this.transactionDetails.concat(
            this.newTransactionDetails
          );

          this.transactionsStore.setTransactionDetails(this.transactionDetails);
          this.transactionDetails =
            this.transactionsStore.getTransactionDetails();
          console.log(this.transactionDetails);
          this.getTransactionTypeCount();
          this.bankTransferCountArray = [];
          this.ussdCountArray = [];
          return event ? event.target.complete() : '';
        },
        (error) => {
          this.gettingData = true;
          this.noConnection = true;
          if (event === null) {
            rotate.classList.remove('icon-reload');
          }
          if (
            error.status === 0 ||
            error.statusText.includes('Unknown Error')
          ) {
            this.transactionsStore.setTransactionDetails([]);
            this.alertService.loadingNullDuration(
              this.globalService.errorText.oops +
                this.globalService.errorText.persists
            );
          }
          return event ? event.target.complete() : '';
        }
      );
  }

  computeDateAndTransactionDetails() {
    const dateText = document.getElementById('date-text');
    const dateTextInner: HTMLElement =
      dateText.shadowRoot.querySelector('.datetime-text');
    dateTextInner.innerText = '';

    this.pickerDate = this.datePipe.transform(this.today, 'yyyy-MM-dd');
    this.dashboardStore.setPickerDate(this.todayDate);

    this.transactionDetails = this.transactionsStore.getTransactionDetails();
    this.accounts = this.dashboardStore.getAccounts();
    this.getAmountReceived();
  }

  storeTransactionDetails(response: any) {
    this.transactionsStore.setTransactionDetails(response);
    this.transactionDetails = this.transactionsStore.getTransactionDetails();
  }

  getAmountReceivedAndBalance() {
    this.getAmountReceived();
    this.getBalance();
  }

  getMerchantAccount() {
    this.merchantAccount = [
      {
        id: null,
        name: this.auth.currentUserValue.details.name,
        businessType: this.auth.currentUserValue.details.businessType,
      },
    ];
  }

  getAccounts() {
    if (this.loginStore.getIsLoggedIn()) {
      this.accounts = this.auth.currentUserValue.details.accounts;
      this.accounts = this.merchantAccount.concat(this.accounts);
      console.log(this.accounts);
      this.dashboardStore.setAccounts(this.accounts);
      this.accounts = this.dashboardStore.getAccounts();
      this.loginStore.removeIsLoggedIn();
    }
    if (this.signupStore.getNewAccount()) {
      this.accounts = [];
      const newAccount = this.signupStore.getNewAccount();
      // this.dashboardStore.setCurrentUserName(newAccount.name);
      this.accountIdsArray.push(newAccount.id);
      this.dashboardStore.setAccountIdsArray(this.accountIdsArray);
      console.log(this.accountIdsArray);
      this.accounts = this.merchantAccount.concat(this.accounts);
      // this.currentUser.details.name = newAccount.name;

      this.accountIdsArray.forEach((id) => {
        this.auth.getSummary(id).subscribe(
          (response: any) => {
            console.log(response);
            this.accounts.push(response.details);
            console.log(this.accounts);
            this.dashboardStore.setAccounts(this.accounts);
            this.accounts = this.dashboardStore.getAccounts();
          },
          (error) => {
            console.log(error);
          }
        );
      });
    }
    this.signupStore.removeNewAccount();
  }

  getCashiers() {
    if (this.merchant) {
      this.auth.getCashiers().subscribe((response: any) => {
        console.log(response);
        this.cashiersStore.setCashiers(response);
        this.cashiersLength = response.length;
      });
    }
  }

  getUpgradeInfo() {
    this.upgradeStore.getUpgradeStatus();
    this.upgradeStore.getUpgradeAccountIds();
    this.upgradeStore.setIsStatusOk(false);
  }

  generateLink() {
    const merchantId =
      this.auth.currentUserValue.details.id ||
      this.auth.currentUserValue.details.merchantId;
    this.firebaseDynamicLinks
      .createShortDynamicLink({
        domainUriPrefix: 'https://bank3d.page.link',
        link: `${url.web}?invitedBy=${merchantId}`,
        androidInfo: {
          androidPackageName: 'com.parkway.bank3d.vaps',
          androidFallbackLink:
            'https://play.google.com/store/apps/details?id=com.parkway.bank3d.vaps',
          androidMinPackageVersionCode: 0,
        },
        iosInfo: {
          iosBundleId: 'com.parkway.bank3d',
          iosFallbackLink: url.web,
          iosIpadFallbackLink: url.web,
          iosIpadBundleId: 'com.parkway.bank3d',
          iosAppStoreId: '1554458438',
        },
      })
      .then(
        (response) => {
          console.log('Referral link created', response);
          this.loginStore.setReferralLink(response);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  registerDeviceId() {
    if (this.merchant && this.platform.is('cordova')) {
      if (
        this.auth.currentUserValue.details.device === null &&
        this.dashboardStore.getIsDeviceIdRegistered() !== 'true'
      ) {
        this.auth.registerDeviceId(this.loginStore.getDeviceId()).subscribe(
          (response) => {
            console.log('Device registered!', response);
            this.dashboardStore.setIsDeviceIdRegistered(true);
          },
          (error) => {
            console.log(error);
          }
        );
      } else if (
        this.auth.currentUserValue.details.device.registrationId !==
          this.loginStore.getDeviceId() &&
        this.dashboardStore.getIsDeviceIdUpdated() !== 'true'
      ) {
        this.auth.updateDeviceId(this.loginStore.getDeviceId()).subscribe(
          (response) => {
            console.log('Device ID updated!', response);
            this.dashboardStore.setIsDeviceIdUpdated(true);
          },
          (error) => {
            console.log(error);
          }
        );
      } else {
        console.log('All is good');
      }
    }
  }

  ionViewWillEnter() {
    document.title = 'Dashboard | Bank3D';
    this.previousEmail = this.loginStore.getPreviousEmail();
    this.cashier = this.auth.currentUserValue.role === 'cashier';
    this.merchant = this.auth.currentUserValue.role === 'merchant';
    this.getMerchantAccount();
    this.getAccounts();
    if (!this.loginStore.getReferralLink()) {
      this.generateLink();
    }
    if (this.previousEmail !== this.auth.currentUserValue.details.email) {
      this.dashboardStore.setCurrentUserName(
        this.auth.currentUserValue.details.name
      );
      this.dashboardStore.setAccountSummary(this.auth.currentUserValue);
      this.dashboardStore.setAccountId(null);
      this.dashboardStore.setActiveIndex('0');
      this.currentUserName = this.dashboardStore.getCurrentUserName();
      this.active = 0;
      this.activeIndex = this.dashboardStore.getActiveIndex();
    }
  }

  ionViewDidEnter() {
    console.log('Initialiase on enter', this.isInfoDismissed);
    this.computeDateAndTransactionDetails();
    this.getUpgradeInfo();
    this.getBalance();
    this.getCashiers();
    this.currentUser.details.name = this.auth.currentUserValue.details.name;
    this.currentUser.role = this.auth.currentUserValue.role;

    this.subscription = this.platform.backButton.subscribeWithPriority(
      99999,
      () => {
        if (this.constructor.name === 'DashboardPage') {
          this.alertService.checkForAlert();
        } else {
          this.location.back();
        }
      }
    );
    if (this.platform.is('ios')) {
      this.subscription = this.platform.backButton.subscribeWithPriority(
        99999,
        () => {
          console.log('Open menu');
        }
      );
    }
    this.registerDeviceId();
    this.loginStore.setPreviousEmail(this.auth.currentUserValue.details.email);
    setTimeout(() => {
      if (document.getElementById('show-more-less')) {
        this.showMoreButton = true;
      }
    }, 1000);

    if (
      this.isInfoDismissed === false &&
      this.accounts.length < 2 &&
      this.accounts === null
    ) {
      this.openSideMenu();
    }
  }

  ionViewDidLeave() {
    this.gettingData = false;
    this.datePickerValue = this.datePipe.transform(
      Date.now(),
      'yyyy-MM-ddTHH:mm:ss.SSS'
    );
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    console.log('Initialiase');
    this.active = this.dashboardStore.getActiveIndex();
    this.getTransactionCount();
    this.offset = '0';

    this.pickerDate = this.datePipe.transform(this.today, 'yyyy-MM-dd');
    this.todayDate = this.datePipe.transform(this.today, 'yyyy-MM-dd');

    this.dashboardStore.setPickerDate(this.todayDate);

    this.getTransactions();
    this.generateLink();
    this.balance = '<img src="assets/icon/loading-balance.svg">';
    this.amountReceived =
      '<img src="assets/icon/loading-balance.svg">';
    this.cordova = this.platform.is('cordova');
    this.mobile = this.platform.is('mobile');
    this.desktop = this.platform.is('desktop');
    this.dashboardStore.getIsBalanceHidden() === 'true'
      ? (this.hideBalance = true)
      : (this.hideBalance = false);
    this.dashboardStore.getIsInfoDismissed() === 'true'
      ? (this.isInfoDismissed = true)
      : (this.isInfoDismissed = false);
    this.dashboardStore.getIsMoreShown() === 'true'
      ? (this.showMore = true)
      : (this.showMore = false);
  }

  ngDoCheck() {
    if (this.transactionsStore.getIsTransactionResolved() === 'true') {
      this.transactionDetails = this.transactionsStore.getTransactionDetails();
      this.transactionsStore.setIsTransactionResolved(false);

      this.getAmountReceivedAndBalance();
    } else {
      return;
    }
    if (this.loginStore.getIsNotificationOpened() === 'true') {
      this.getAmountReceivedAndBalance();
      this.loginStore.setIsNotificationOpened(false);
    }
  }
}
